<template>
  <div class="form-read-only">
    <div
      v-for="(component, index) in componentsList"
      :key="component._uuid"
    >
      <component
        :is="`${component.type}-read-only`"
        v-show="!hiddenComponent(component)"
        :component="component"
        :components="components"
        :index="index"
        :value="jsonData[component.key]"
      />
    </div>
  </div>
</template>

<script>
// Vuex
// https://vuex.vuejs.org/guide/state.html#the-mapstate-helper
import { mapState } from 'vuex'

// Components
import TextReadOnly from '@/components/text/TextReadOnly.vue'
import PasswordReadOnly from '@/components/password/PasswordReadOnly.vue'
import NumberReadOnly from '@/components/number/NumberReadOnly.vue'
import SelectReadOnly from '@/components/select/SelectReadOnly.vue'
import SelectApiReadOnly from '@/components/select-api/SelectApiReadOnly.vue'
import SelectResourceReadOnly from '@/components/select-resource/SelectResourceReadOnly.vue'
import TextareaReadOnly from '@/components/textarea/TextAreaReadOnly.vue'
import CheckboxSingleReadOnly from '@/components/checkbox-single/CheckboxSingleReadOnly.vue'
import CheckboxReadOnly from '@/components/checkbox/CheckboxReadOnly.vue'
import RadioReadOnly from '@/components/radio/RadioReadOnly.vue'
import FileReadOnly from '@/components/file/FileReadOnly.vue'
import DatepickerReadOnly from '@/components/datepicker/DatepickerReadOnly.vue'
import HelpBlockReadOnly from '@/components/help-block/HelpBlockReadOnly.vue'
import GroupReadOnly from '@/components/group/GroupReadOnly.vue'
import { componentType } from '@/enums/constantes'

export default {
  props: {
    components: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      limit: -1
    }
  },
  name: 'FormReadOnly',
  components: {
    TextReadOnly,
    PasswordReadOnly,
    NumberReadOnly,
    SelectReadOnly,
    SelectApiReadOnly,
    SelectResourceReadOnly,
    TextareaReadOnly,
    CheckboxSingleReadOnly,
    CheckboxReadOnly,
    RadioReadOnly,
    FileReadOnly,
    DatepickerReadOnly,
    HelpBlockReadOnly,
    GroupReadOnly
  },
  computed: {
    // The mapState Helper
    // https://vuex.vuejs.org/guide/state.html#the-mapstate-helper
    ...mapState({
      formDataIdBind: state => state.formDataId.data,
      formJson: state => state.formJson,
      variables: state => state.config.variables,
      json: state => state.config.json,
      showOnly: state => state.showOnly
    }),
    componentsList () {
      let size = this.showOnly && this.showOnly.size ? this.showOnly.size : -1
      const components = this.checkComponentsIsHidden(this.components)

      if (this.showOnly && this.showOnly.dataList) {
        const componentsDataList = this.filterComponentsDataList(components)
        if (componentsDataList.count > 0) return componentsDataList.data
        // Caso não tenha componentes com a propriedade dataList, retorna os 2 primeiros componentes
        size = 2
      }

      if (size < 1) {
        return components
      }

      const comp = []
      let count = 0
      let key = 0

      while (count < size) {
        const item = this.sliceGroup(components[key], size - count)

        comp.push(item.component)

        count += item.count
        key++
      }

      return comp
    },
    jsonData () {
      return this.formDataIdBind || this.json
    }
  },
  methods: {
    /**
     * Verifica as validações do formulário e envia o resultado
     * para o metodo sendValidate
     * @param  {Object} event Objeto da mensagem recebida
     */
    showOnlyEvent (event) {
      const payload = event.data
      if (payload.origin === 'formBuilderSDK') {
        if (payload.type === 'command' && payload.action === 'showOnly') {
          this.$store.dispatch('setShowOnly', payload.data)
        }
      }
    },
    checkComponentsIsHidden (components) {
      const result = []
      components.forEach(component => {
        if (component.type === componentType.group) {
          const componentGroup = { ...component }
          componentGroup.components = componentGroup.components.filter(x => !this.hiddenComponent(x))
          if (componentGroup.components.length) result.push(componentGroup)
        } else if (!this.hiddenComponent(component)) result.push(component)
      })
      return result
    },
    filterComponentsDataList (components) {
      const result = []
      let count = 0
      components.forEach(component => {
        if (component.type === componentType.group) {
          const componentGroup = { ...component }
          componentGroup.components = componentGroup.components.filter(x => x.dataListLabel)
          if (componentGroup.components.length) {
            count += componentGroup.components.length
            result.push(componentGroup)
          }
        } else if (component.dataListLabel) {
          result.push(component)
          count++
        }
      })
      return {
        data: result,
        count
      }
    },
    sliceGroup (component, size) {
      // Segurança caso seja informado uma quantidade maior que a cadastrada em um formulário
      if (!component) {
        return {
          component: null,
          count: size
        }
      }
      if (component.type === componentType.group) {
        const componentGroup = { ...component }
        componentGroup.components = componentGroup.components.slice(0, size)
        return {
          component: componentGroup,
          count: componentGroup.components.length
        }
      }
      return {
        component: component,
        count: 1
      }
    },
    hiddenComponent (component) {
      return this.$checkConditionalViewAllow(component, this.components, this.variables, this.jsonData, true)
    }
  },
  created () {
    this.$bindEvent(window, 'message', (e) => this.showOnlyEvent(e))
  }
}
</script>
